import { useEffect } from 'react';
import styles from './Logout.module.scss';
import { BrLoading } from '@govbr-ds/react-components';

function Logout() {
  useEffect(() => {
    localStorage.clear();
    sessionStorage.clear();
    const urlAtual = window.location.origin;

    window.location.href = urlAtual;
  }, []);
  return (
    <div className={styles.loadingContainer}>
      <div className={styles.container}>
        <BrLoading large label="Finalizando seu logout e redirecionando para página principal da plataforma" />
      </div>
    </div>
  );
}

export default Logout;
